var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLifetimePlanSelected ? _c('PaymentFormSingleCharge', {
    attrs: {
      "item-selected": _vm.itemSelected,
      "is-onboarding": _vm.isOnboarding,
      "promo-code": _vm.promoCode
    },
    on: {
      "loaded": function ($event) {
        return _vm.$emit('loaded');
      },
      "payment-success": _vm.subscriptionSuccess
    }
  }) : _c('PaymentFormComponent', {
    attrs: {
      "item-selected": _vm.itemSelected,
      "is-onboarding": _vm.isOnboarding,
      "promo-code": _vm.promoCode
    },
    on: {
      "loaded": function ($event) {
        return _vm.$emit('loaded');
      },
      "payment-success": _vm.subscriptionSuccess
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }